export default {
  functional: true,
  render: (h, ctx) => {
    const { tag } = ctx.props;
    return h(
      tag || 'p',
      { style: { color: '#F56C6C' } },
      ctx.children || ctx.props.text
    );
  }
};
